import type { ReactNode } from "react";

interface DetailRowProps {
  label: string;
  value: ReactNode;
}

/**
 * One label / value line in a detail surface.
 *
 * The payment detail view and the entity quick-view stack each carried a
 * byte-identical private copy of this, so a spacing or alignment fix landed on
 * one surface and not the other.
 */
export function DetailRow({ label, value }: DetailRowProps) {
  return (
    <div className="flex justify-between gap-4 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-right">{value}</span>
    </div>
  );
}
